import UnknownProfile from "../../../assets/unknown_profile.jpg";
import fileType from "./file-type/index";

export function logTitle(message) {
  const consoleTitleStyles = ["background: black", "color: white", "padding: 2px"].join(";");

  console.log("%c" + message, consoleTitleStyles);
}

export function getFileTypeFromPreview(file) {
  const xhr = new XMLHttpRequest();

  return new Promise((resolve) => {
    xhr.open("GET", file.preview);
    xhr.responseType = "arraybuffer";

    xhr.onload = () => {
      resolve(fileType(new Uint8Array(xhr.response)));
    };

    xhr.send();
  });
}

export function getAttachmentFromPreview(preview) {
  const xhr = new XMLHttpRequest();

  return new Promise((resolve) => {
    xhr.open("GET", preview);
    xhr.responseType = "arraybuffer";

    xhr.onload = () => {
      resolve(new Uint8Array(xhr.response));
    };

    xhr.send();
  });
}

export function bufferToBase64(buf) {
  const binstr = Array.prototype.map
    .call(buf, function (ch) {
      return String.fromCodePoint(ch);
    })
    .join("");
  return btoa(binstr);
}

// https://stackoverflow.com/questions/32702431/display-images-fetched-from-s3
export function encode(data) {
  let str = "";
  for (let value of data) {
    str = str + String.fromCodePoint(value);
  }

  return btoa(str).replaceAll(/.{76}(?=.)/g, "$&\n");
}

export function logError(message, component, method) {
  console.error(message);
  console.error(component + ": " + method);
}

export async function generateCarlSagan() {
  let image = new Image();

  const attachment = await getAttachmentFromPreview(UnknownProfile);

  const avatarFileType = fileType(new Uint8Array(attachment));

  image.src = "data:" + avatarFileType.mime + ";base64," + encode(attachment);

  return image;
}
